import { fetchApi } from "@/api/base";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export const useDeletePriceAlert = () => {
  const queryClient = useQueryClient();

  return useMutation({
    async mutationFn(alertId: string) {
      await fetchApi(`/api/price-alerts/${alertId}`, {
        method: "DELETE",
      });
    },
    async onSuccess() {
      await queryClient.invalidateQueries({
        queryKey: ["price-alerts"],
        exact: false,
      });
    },
  });
};
